/* eslint-disable no-useless-escape */
// eslint-disable-next-line no-undef
tinymce.addI18n("eu", {
  Redo: "Berregin",
  Undo: "Desegin",
  Cut: "Ebaki",
  Copy: "Kopiatu",
  Paste: "Itsatsi",
  "Select all": "Hautatu dena",
  "New document": "Dokumentu berria",
  Ok: "Ondo",
  Cancel: "Ezeztatu",
  "Visual aids": "Laguntza bisualak",
  Bold: "Lodia",
  Italic: "Etzana",
  Underline: "Azpimarratua",
  Strikethrough: "Marratua",
  Superscript: "Goi-indizea",
  Subscript: "Azpiindizea",
  "Clear formatting": "Ezabatu formatua",
  "Align left": "Lerrokatu ezkerrean",
  "Align center": "Lerrokatu erdian",
  "Align right": "Lerrokatu eskuinean",
  Justify: "Justifikatuta",
  "Bullet list": "Bulet zerrenda",
  "Numbered list": "Zenbaki-zerrenda",
  "Decrease indent": "Txikitu koska",
  "Increase indent": "Handitu koska",
  Close: "Itxi",
  Formats: "Formatuak",
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.":
    "Zure nabigatzaileak ez du arbela zuzenean erabiltzeko euskarririk. Mesedez erabili CTRL+X/C/V teklatuko lasterbideak.",
  Headers: "Goiburuak",
  "Header 1": "1. goiburua",
  "Header 2": "2. goiburua",
  "Header 3": "3. goiburua",
  "Header 4": "4. goiburua",
  "Header 5": "5. goiburua",
  "Header 6": "6. goiburua",
  Headings: "Izenburuak",
  "Heading 1": "1. izenburua",
  "Heading 2": "2. izenburua",
  "Heading 3": "3. izenburua",
  "Heading 4": "4. izenburua",
  "Heading 5": "5. izenburua",
  "Heading 6": "6. izenburua",
  Preformatted: "Aurreformateatuta",
  Div: "Div",
  Pre: "Pre",
  Code: "Kodea",
  Paragraph: "Paragrafoa",
  Blockquote: "Blockquote",
  Inline: "Txertatuta",
  Blocks: "Blokeak",
  "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.":
    "Itsatsi testu arrunt moduan dago orain. Edukiak testu arruntak bezala itsatsiko dira aukera hau itzaltzen duzunera arte.",
  Fonts: "Letra-motak",
  "Font Sizes": "Letra-tamainak",
  Class: "Klasea",
  "Browse for an image": "Irudia arakatu",
  OR: "EDO",
  "Drop an image here": "Irudia hona ekarri",
  Upload: "Kargatu",
  Block: "Blokea",
  Align: "Lerrokatu",
  Default: "Lehenetstia",
  Circle: "Zirkulua",
  Disc: "Diskoa",
  Square: "Karratua",
  "Lower Alpha": "Behe alfa",
  "Lower Greek": "Behe grekoa",
  "Lower Roman": "Behe erromatarra",
  "Upper Alpha": "Goi alfa",
  "Upper Roman": "Goi erromatarra",
  "Anchor...": "Aingura...",
  Name: "Izena",
  Id: "Id",
  "Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.":
    "Ida hizki batekin hasi behar da, jarraian hizkiak, zenbakiak, gidoiak, puntuak, bi-puntu edo azpiko marrak bakarrik izan ditzake.",
  "You have unsaved changes are you sure you want to navigate away?":
    "Gorde gabeko aldaketak dituzu, zihur zaude hemendik irten nahi duzula?",
  "Restore last draft": "Leheneratu azken zirriborroa",
  "Special character...": "Karaktere bereziak...",
  "Source code": "Iturburu-kodea",
  "Insert/Edit code sample": "Txertatu/editatu kode adibidea",
  Language: "Hizkuntza",
  "Code sample...": "Kode adibidea...",
  "Color Picker": "Kolore-hautatzailea",
  R: "R",
  G: "G",
  B: "B",
  "Left to right": "Ezkerretik eskuinera",
  "Right to left": "Eskuinetik ezkerrera",
  "Emoticons...": "Emotikonoak...",
  "Metadata and Document Properties":
    "Metadatuak eta dokumentuaren propietateak",
  Title: "Titulua",
  Keywords: "Hitz gakoak",
  Description: "Deskribapena",
  Robots: "Robotak",
  Author: "Egilea",
  Encoding: "Encoding",
  Fullscreen: "Pantaila osoa",
  Action: "Akzioa",
  Shortcut: "Laster tekla",
  Help: "Laguntza",
  Address: "Helbidea",
  "Focus to menubar": "Fokoa menu-barrara eraman",
  "Focus to toolbar": "Fokoa tresna-barrara eraman",
  "Focus to element path": "Fokoa elementuaren bidera eraman",
  "Focus to contextual toolbar": "Fokoa kontestuko tresna-barrara eraman",
  "Insert link (if link plugin activated)":
    "Lotura txertatu (lotura plugina aktibatuta badago)",
  "Save (if save plugin activated)":
    "Gorde (gordetzeko plugina aktibatuta badago)",
  "Find (if searchreplace plugin activated)":
    "Bilatu (bilatuordezkatu plugina instalatuta badago)",
  "Plugins installed ({0}):": "Instalatutako pluginak ({0}):",
  "Premium plugins:": "Premium pluginak:",
  "Learn more...": "Gehiago ikasi...",
  "You are using {0}": "{0} erabiltzen ari zara",
  Plugins: "Pluginak",
  "Handy Shortcuts": "Laster-tekla erabilgarriak",
  "Horizontal line": "Marra horizontala",
  "Insert/edit image": "Irudia txertatu/editatu",
  "Image description": "Irudiaren deskribapena",
  Source: "Iturburua",
  Dimensions: "Neurriak",
  "Constrain proportions": "Zerraditu proportzioak",
  General: "Orokorra",
  Advanced: "Aurreratua",
  Style: "Estiloa",
  "Vertical space": "Hutsune bertikala",
  "Horizontal space": "Hutsune horizontala",
  Border: "Ertza",
  "Insert image": "Irudia txertatu",
  "Image...": "Irudia...",
  "Image list": "Irudi zerrenda",
  "Rotate counterclockwise": "Erlojuaren aurkako eran biratu",
  "Rotate clockwise": "Erlojuaren eran biratu",
  "Flip vertically": "Bertikalki irauli",
  "Flip horizontally": "Horizontalki irauli",
  "Edit image": "Irudia editatu",
  "Image options": "Irudiaren aukerak",
  "Zoom in": "Zooma handiagotu",
  "Zoom out": "Zooma txikiagotu",
  Crop: "Moztu",
  Resize: "Tamaina aldatu",
  Orientation: "Orientazioa",
  Brightness: "Distira",
  Sharpen: "Zorroztu",
  Contrast: "Kontrastatu",
  "Color levels": "Kolore mailak",
  Gamma: "Gamma",
  Invert: "Biratu",
  Apply: "Gorde",
  Back: "Atzera",
  "Insert date/time": "Data/ordua txertatu",
  "Date/time": "Data/ordua",
  "Insert/Edit Link": "Lotura txertatu/aldatu...",
  "Insert/edit link": "Esteka txertatu/editatu",
  "Text to display": "Bistaratzeko testua",
  Url: "Url",
  "Open link in...": "Lotura hemen ireki...",
  "Current window": "Leiho hau",
  None: "Bat ere ez",
  "New window": "Lehio berria",
  "Remove link": "Kendu esteka",
  Anchors: "Estekak",
  "Link...": "Esteka...",
  "Paste or type a link": "Itsatsu edo idatzi lotura",
  "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?":
    "Sartu duzun URL-ak e-posta helbidea dela dirudi. Nahi duzu dagokion mailto: aurrizkia gehitzea?",
  "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?":
    "Sartu duzun URL-ak kanpoko esteka dela dirudi. Nahi duzu dagokion http:// aurrizkia gehitzea?",
  "Link list": "Loturen zerrenda",
  "Insert video": "Bideoa txertatu",
  "Insert/edit video": "Bideoa txertatu/editatu",
  "Insert/edit media": "Media txertatu/editatu",
  "Alternative source": "Iturburu alternatiboa",
  "Alternative source URL": "Ordezko jatorri URL-a",
  "Media poster (Image URL)": "Media posterra (irudiaren URL-a)",
  "Paste your embed code below:": "Itsatsi hemen zure enkapsulatzeko kodea:",
  Embed: "Kapsulatu",
  "Media...": "Multimedia...",
  "Nonbreaking space": "Zuriune zatiezina",
  "Page break": "Orrialde-jauzia",
  "Paste as text": "Itsatsi testu bezala",
  Preview: "Aurrebista",
  "Print...": "Inprimatu...",
  Save: "Gorde",
  Find: "Bilatu",
  "Replace with": "Honekin ordeztu",
  Replace: "Ordeztu",
  "Replace all": "Ordeztu dena",
  Previous: "Aurrekoa",
  Next: "Hurrengoa",
  "Find and replace...": "Bilatu eta ordezkatu...",
  "Could not find the specified string.":
    "Ezin izan da zehaztutako katea aurkitu.",
  "Match case": "Maiuskula/minuskula",
  "Find whole words only": "Hitz osoak bakarrik bilatu",
  "Spell check": "Hizkuntza zuzenketa",
  Ignore: "Ez ikusi",
  "Ignore all": "Ez ikusi guztia",
  Finish: "Amaitu",
  "Add to Dictionary": "Hiztegira gehitu",
  "Insert table": "Txertatu taula",
  "Table properties": "Taularen propietateak",
  "Delete table": "Taula ezabatu",
  Cell: "Gelaxka",
  Row: "Errenkada",
  Column: "Zutabea",
  "Cell properties": "Gelaxkaren propietateak",
  "Merge cells": "Batu gelaxkak",
  "Split cell": "Banatu gelaxkak",
  "Insert row before": "Txertatu errenkada aurretik",
  "Insert row after": "Txertatu errenkada ostean",
  "Delete row": "Ezabatu errenkada",
  "Row properties": "Errenkadaren propietateak",
  "Cut row": "Ebaki errenkada",
  "Copy row": "Kopiatu errenkada",
  "Paste row before": "Itsatsi errenkada aurretik",
  "Paste row after": "Itsatsi errenkada ostean",
  "Insert column before": "Txertatu zutabe aurretik",
  "Insert column after": "Txertatu zutabea ostean",
  "Delete column": "Ezabatu zutabea",
  Cols: "Zutabeak",
  Rows: "Errenkadak",
  Width: "Zabalera",
  Height: "Altuera",
  "Cell spacing": "Gelaxka arteko tartea",
  "Cell padding": "Gelaxken betegarria",
  "Show caption": "Erakutsi irudi-oina erakutsi",
  Left: "Ezkerra",
  Center: "Erdia",
  Right: "Eskuina",
  "Cell type": "Gelaxka mota",
  Scope: "Esparrua",
  Alignment: "Lerrokatzea",
  "H Align": "Lerrokatze horizontala",
  "V Align": "Lerrokatze bertikala",
  Top: "Goian",
  Middle: "Erdian",
  Bottom: "Behean",
  "Header cell": "Goiburuko gelaxka",
  "Row group": "Lerro taldea",
  "Column group": "Zutabe taldea",
  "Row type": "Lerro mota",
  Header: "Goiburua",
  Body: "Gorputza",
  Footer: "Oina",
  "Border color": "Inguruko marraren kolorea",
  "Insert template...": "Txantiloia txertatu...",
  Templates: "Txantiloiak",
  Template: "Txantiloia",
  "Text color": "Testuaren kolorea",
  "Background color": "Atzeko kolorea",
  "Custom...": "Pertsonalizatu",
  "Custom color": "Pertsonalizatutako kolorea",
  "No color": "Kolorerik ez",
  "Remove color": "Kendu kolorea",
  "Table of Contents": "Edukien taula",
  "Show blocks": "Erakutsi blokeak",
  "Show invisible characters": "Erakutsi karaktere izkutuak",
  "Word count": "Hizki-kontaketa",
  Count: "Zenbatu",
  Document: "Dokumentua",
  Selection: "Aukera",
  Words: "Hitzak",
  "Words: {0}": "Hitzak: {0}",
  "{0} words": "{0} hitz",
  File: "Fitxategia",
  Edit: "Editatu",
  Insert: "Sartu",
  View: "Ikusi",
  Format: "Formatua",
  Table: "Taula",
  Tools: "Tresnak",
  "Powered by {0}": "{0}rekin egina",
  "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help":
    "Testu aberastuko area. Sakatu ALT-F9 menurako. Sakatu ALT-F10 tresna-barrarako. Sakatu ALT-0 laguntzarako",
  "Image title": "Irudiaren izenburua",
  "Border width": "Ertzaren zabalera",
  "Border style": "Ertzaren estiloa",
  Error: "Errorea",
  Warn: "Oharra",
  Valid: "Zuzena",
  "To open the popup, press Shift+Enter":
    "Leiho berria irekitzeko, sakatu Shift+Enter",
  "Rich Text Area. Press ALT-0 for help.":
    "Testu aberastuko area. Sakatu ALT-0 laguntza lortzeko.",
  "System Font": "Sistemaren letra-mota",
  "Failed to upload image: {0}": "Errorea gertatu da irudia igotzean: {0}",
  "Failed to load plugin: {0} from url {1}":
    "Errorea gertatu da {0} plugina kargatzean {1} url-tik",
  "Failed to load plugin url: {0}":
    "Errorea gertatu da pluginaren url-a kargatzean: {0}",
  "Failed to initialize plugin: {0}":
    "Errorea gertatu da plugina hasieratzean: {0}",
  example: "adibidea",
  Search: "Bilatu",
  All: "Guztiak",
  Currency: "Moneta",
  Text: "Testua",
  Quotations: "Aipuak",
  Mathematical: "Matematika",
  "Extended Latin": "Latin zabaldua",
  Symbols: "Ikurrak",
  Arrows: "Geziak",
  "User Defined": "Erabiltzaileak definitutakoak",
  "dollar sign": "dolarraren ikurra",
  "currency sign": "monetaren ikurra",
  "euro-currency sign": "euroaren ikurra",
  "colon sign": "bi puntuen ikurra",
  "cruzeiro sign": "cruzeiroaren ikurra",
  "french franc sign": "libera frantsesaren ikurra",
  "lira sign": "liraren ikurra",
  "mill sign": "millaren ikurra",
  "naira sign": "naira ikurra",
  "peseta sign": "pezetaren ikurra",
  "rupee sign": "rupiaren ikurra",
  "won sign": "wonaren ikurra",
  "new sheqel sign": "sheqel berriaren ikurra",
  "dong sign": "dongaren ikurra",
  "kip sign": "kiparen ikurra",
  "tugrik sign": "tugrikaren ikurra",
  "drachma sign": "drakmaren ikurra",
  "german penny symbol": "alemaniako peniaren ikurra",
  "peso sign": "pesoaren ikurra",
  "guarani sign": "guaraniaren ikurra",
  "austral sign": "australaren ikurra",
  "hryvnia sign": "hryvniaren ikurra",
  "cedi sign": "cediaren ikurra",
  "livre tournois sign": "libre tournoisaren ikurra",
  "spesmilo sign": "spesmiloaren ikurra",
  "tenge sign": "tengearen ikurra",
  "indian rupee sign": "indiako rupiaren ikurra",
  "turkish lira sign": "lira turkiarraren ikurra",
  "nordic mark sign": "iparraldeko markoaren ikurra",
  "manat sign": "manataren ikurra",
  "ruble sign": "rubloaren ikurra",
  "yen character": "yenaren karakterea",
  "yuan character": "yuanaren karakterea",
  "yuan character, in hong kong and taiwan":
    "yuanaren karakterea, hong kong eta taiwanen",
  "yen/yuan character variant one": "yen/yuan karakterearen 1go bariantea",
  "Loading emoticons...": "Emotikonoak kargatzen...",
  "Could not load emoticons": "Ezin izan dira emotikonoak kargatu",
  People: "Jendea",
  "Animals and Nature": "Animaliak eta natura",
  "Food and Drink": "Janari eta edaria",
  Activity: "Ekintzak",
  "Travel and Places": "Bidaiak eta lekuak",
  Objects: "Objektuak",
  Flags: "Banderak",
  Characters: "Karaktereak",
  "Characters (no spaces)": "Karaktereak (espaziorik gabe)",
  "{0} characters": "{0} karaktere",
  "Error: Form submit field collision.":
    "Errorea: formularioaren eremuetan talka gertatu da.",
  "Error: No form element found.": "Errorea: ez da formularioa aurkitu.",
  Update: "Eguneratu",
  "Color swatch": "Koloreak",
  Turquoise: "Turkesa",
  Green: "Berdea",
  Blue: "Urdina",
  Purple: "Morea",
  "Navy Blue": "Itsas-urdina",
  "Dark Turquoise": "Turkesa iluna",
  "Dark Green": "Berde iluna",
  "Medium Blue": "Tarteko urdina",
  "Medium Purple": "Tarteko morea",
  "Midnight Blue": "Gauerdiko urdina",
  Yellow: "Horia",
  Orange: "Laranja",
  Red: "Gorria",
  "Light Gray": "Gris argia",
  Gray: "Grisa",
  "Dark Yellow": "Hori iluna",
  "Dark Orange": "Laranja iluna",
  "Dark Red": "Gorri iluna",
  "Medium Gray": "Tarteko grisa",
  "Dark Gray": "Gris iluna",
  "Light Green": "Berde argia",
  "Light Yellow": "Hori argia",
  "Light Red": "Gorri argia",
  "Light Purple": "More argia",
  "Light Blue": "Urdin argia",
  "Dark Purple": "More iluna",
  "Dark Blue": "Urdin iluna",
  Black: "Beltza",
  White: "Zuria",
  "Switch to or from fullscreen mode":
    "Pantaila osoko modura joan edo handik itzuli",
  "Open help dialog": "Laguntza elkarrizketa ireki",
  history: "historia",
  styles: "estiloak",
  formatting: "formatua",
  alignment: "lerrokatzea",
  indentation: "koska",
  "permanent pen": "boligrafo iraunkorra",
  comments: "iruzkinak",
  "Format Painter": "Formatua kopiatu",
  "Insert/edit iframe": "Txertatu/editatu bideoa",
  Capitalization: "Letra larriak",
  lowercase: "Letra xeheak",
  UPPERCASE: "Maiuskula",
  "Title Case": "Izenburu kasua",
  "Permanent Pen Properties": "Boligrafo iraunkorraren ezaugarriak",
  "Permanent pen properties...": "Boligrafo iraunkorraren ezaugarriak...",
  Font: "Letra-motak",
  Size: "Tamaina",
  "More...": "Gehiago...",
  "Spellcheck Language": "Zuzenketa ortografikoaren hizkuntza",
  "Select...": "Aukeratu...",
  Preferences: "Lehentasunak",
  Yes: "Bai",
  No: "Ez",
  "Keyboard Navigation": "Teklatuaren nabigazioa",
  Version: "Bertsioa",
  Anchor: "Esteka",
  "Special character": "Karaktere bereziak",
  "Code sample": "Kode adibidea",
  Color: "Kolorea",
  Emoticons: "Irrifartxoak",
  "Document properties": "Dokumentuaren propietateak",
  Image: "Irudia",
  "Insert link": "Esteka txertatu",
  Target: "Target",
  Link: "Lotura",
  Poster: "Poster-a",
  Media: "Media",
  Print: "Inprimatu",
  Prev: "Aurrekoa",
  "Find and replace": "Bilatu eta ordeztu",
  "Whole words": "hitz osoak",
  Spellcheck: "Egiaztapenak",
  Caption: "Epigrafea",
  "Insert template": "Txertatu txantiloia",
});
